/* Ince siyah lüks şerit — bölümler arası nefes payı (bordo/altın paletle uyumlu, isteğe bağlı el yazısı cümle). */
export function BlackDivider({ kanji = "和", line = "" }) {
  return (
    <div aria-hidden className="relative overflow-hidden bg-[#0A0508] py-6 sm:py-8" data-testid={`black-divider-${kanji}`}>
      <div className="flex items-center justify-center gap-5">
        <span className="h-px w-16 sm:w-28 bg-gradient-to-r from-transparent to-[#C9A96A]/50" />
        <span className="font-magserif text-2xl sm:text-3xl text-[#C9A96A]/80 select-none">{kanji}</span>
        <span className="h-px w-16 sm:w-28 bg-gradient-to-l from-transparent to-[#C9A96A]/50" />
      </div>
      {line && (
        <p className="mt-2 text-center font-hand italic text-lg sm:text-xl text-[#C9A96A]/65 select-none">{line}</p>
      )}
    </div>
  );
}
